import { Avatar, Box, Button, Divider, HStack, IconButton, Input, Text, Textarea, VStack } from "@chakra-ui/react";
import { Add, Close, DiamondOutlined, KeyboardArrowDown, Send, ThumbDownOutlined, ThumbUpOutlined, Undo } from "@mui/icons-material";
import React, { useRef } from "react";
import apiClient from "../../clients/apiClient.js";
import { useParams } from "react-router-dom";

const ConversationPanel = ({ setIsEntityChatOpen, entityChatData, setEntityChatData, allCollaborators, applySuggestion, selectedConversationTab, setSelectedConversationTab }) => {
    const [collaboratorMapping, setCollaboratorMapping] = React.useState({});
    const [typedMessage, setTypedMessage] = React.useState("");

    const {formId} = useParams();

    const textareaRef = useRef(null);
    const chatBoxRef = useRef(null);

    const improveWithAI = [{
        name: "Rewrite",
        value: "Hi Thalamus, can you please rewrite the answer"
    }, {
        name: "Change tone",
        value: "Hi Thalamus, can you please change the tone of the answer to persuasive"
    }, {
        name: "Change language",
        value: "Hi Thalamus, can you please change the language of the answer to French"
    }, {
        name: "...",
        value: "Hi Thalamus, can you please "
    }]
    
    React.useEffect(() => {
        const textarea = textareaRef.current;
        if (!textarea) return;
    
        // Reset height so scrollHeight is accurate
        textarea.style.height = "auto";
    
        const scrollHeight = textarea.scrollHeight;

        const MIN_HEIGHT = 32;
        const MAX_HEIGHT = 80;
        console.log("[ConversationPanel] scrollHeight", textarea.scrollHeight, textarea.offsetHeight)
    
        // If content is below the max, expand
       if (scrollHeight <= MAX_HEIGHT) {
          textarea.style.overflowY = "auto";
          textarea.style.height = `${Math.max(scrollHeight, MIN_HEIGHT)}px`;
          textarea.style.maxHeight = `${Math.max(scrollHeight, MIN_HEIGHT)}px`;
          if (selectedConversationTab == "ai_chat") {
              chatBoxRef.current.style.height = `calc(100% - 20px - -32px - 16px - 88px - 24px - ${Math.max(scrollHeight, MIN_HEIGHT)}px) - 24px`
            
          } else {
              chatBoxRef.current.style.height = `calc(100% - 20px - -32px - 16px - 88px - 24px - ${Math.max(scrollHeight, MIN_HEIGHT)}px)`
          }
        } else {
          // Cap height and enable scroll
          textarea.style.overflowY = "auto";
          textarea.style.height = `${MAX_HEIGHT}px`;
          textarea.style.maxHeight = `${MAX_HEIGHT}px`;
        }
      }, [typedMessage]);

    React.useEffect(() => {
        const mapping = {};
        allCollaborators?.forEach((item) => {
            mapping[item.email] = item;
        });

        setCollaboratorMapping(mapping);
    }, [allCollaborators]);

    const getCollaborators = () => {
        const collaborators = allCollaborators?.filter((item) => {
            return entityChatData?.collaborators?.includes(item.email)
        })

        return collaborators
    }

    const getConversation = () => {
        for (let i = 0; i < entityChatData?.conversations?.length; i++) {
            if (selectedConversationTab == "collaborator_chat" && (entityChatData?.conversations[i].conversation_type == "" || entityChatData?.conversations[i].conversation_type == "collaborator_chat")) {
                return entityChatData?.conversations[i]
            } else if (selectedConversationTab == "ai_chat" && entityChatData?.conversations[i].conversation_type == "ai_chat") {
                return entityChatData?.conversations[i]
            }
        }

        return null
    }

    const updateConversationInEntityChatData = (conversationId, message) => {
        setEntityChatData((prev) => {
            const updatedConversations = prev.conversations.map(convo => {
                if (convo.conversation_id === conversationId) {
                    return {
                        ...convo,
                        messages: [...convo.messages, message]
                    };
                }
                return convo;
            });
            return {
                ...prev,
                conversations: updatedConversations
            };
        });
    }

    const addConversationToEntityChatData = (conversation) => {
        setEntityChatData((prev) => {
            const updatedConversations = [...(prev.conversations ?? []), conversation];
            console.log("[ConversationPanel] addConversationToEntityChatData", updatedConversations)
            return {
                ...prev,
                conversations: updatedConversations
            };
        });
    }

    const handleSendMessage = (conversation, conversation_type) => {
        if (typedMessage.trim() !== "") {
            setTypedMessage("");
            if (conversation == null || conversation?.messages?.length == 0) {
                apiClient.post('/forms/take-form-action', {
                    form_id: formId,
                    entity_id: entityChatData.id,
                    action_type: "start_conversation",
                    action_data: {
                        start_conversation: {
                            conversation_type: conversation_type,
                            message_type: "text",
                            message_data: {
                                text: typedMessage
                            }
                        }
                    }
                }).then((response) => {
                    response.data.conversation_type = conversation_type
                    addConversationToEntityChatData(response.data)
                })
            } else {
                apiClient.post('/forms/take-form-action', {
                    form_id: formId,
                    entity_id: entityChatData.id,
                    action_type: "reply",
                    action_data: {
                        reply: {
                            conversation_id: conversation.conversation_id,
                            conversation_type: conversation_type,
                            message_type: "text",
                            message_data: {
                                text: typedMessage
                            }
                        }
                    }
                }).then((response) => {
                    response.data.conversation_type = conversation_type
                    updateConversationInEntityChatData(conversation.conversation_id, response.data.messages[0])
                })
            }
        }
    };

    const handleKeyDown = (e, conversation, conversation_type) => {
        console.log("[ConversationPanel] handleKeyDown", conversation)
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage(conversation, conversation_type);
        }
    };

    return (
        <VStack
            position="fixed"
            top="0"
            right="0"
            width="30%"
            minW={"480px"}
            height="100%"
            bg="white"
            boxShadow="-2px 0 5px rgba(0, 0, 0, 0.1)"
            zIndex="1000"
            spacing={0}
        >
            {console.log("[ConversationPanel] entityChatData", entityChatData)}
            <Box height={"52px"} paddingY={"16px"} display={"flex"} justifyContent={"space-between"} width={"100%"}>
                <HStack>
                    <Button
                        height={"52px"}
                        bgColor={selectedConversationTab == "ai_chat" ? '#FFFFFF' : 'transparent'}
                        borderBottom={selectedConversationTab == "ai_chat" ? '2px solid #000': "1px solid transparent"}
                        borderRadius={0}
                        onClick={() => setSelectedConversationTab("ai_chat")}
                        _hover={{
                            backgroundColor: selectedConversationTab == "ai_chat" ? '#FFFFFF' : '#E2E8F0',
                        }}
                    >
                        <Text fontSize="18px" color="#fffff"> Improve with AI </Text>
                    </Button>
                    <Button 
                        height={"52px"}
                        bgColor={selectedConversationTab == "collaborator_chat" ? '#FFFFFF' : 'transparent'}
                        borderBottom={selectedConversationTab == "collaborator_chat" ? '2px solid #000': "1px solid transparent"}
                        borderRadius={0}
                        _hover={{
                            backgroundColor: selectedConversationTab == "collaborator_chat" ? '#FFFFFF' : '#E2E8F0',
                        }}
                        onClick={() => setSelectedConversationTab("collaborator_chat")}
                    >
                        <Text fontSize="18px" color="#fffff"> Comments </Text>
                    </Button>
                </HStack>
                <IconButton
                    sx={{
                        padding: "0",
                        margin: "0",
                        backgroundColor: "transparent",
                        "&:hover": {
                            backgroundColor: "transparent",
                        },
                        height: "20px",
                        width: "20px",
                    }}
                >
                    <Close
                        onClick={() => setIsEntityChatOpen(false)}
                        sx={{
                            padding: "0",
                            margin: "0",
                            fontSize: "20px",
                            color: "#5d5d5d",
                            "&:hover": {
                                color: "#5d5d5d",
                            }
                        }}
                    />
                </IconButton>
            </Box>
            <Divider margin={0} padding={0}/>
            <Box ref={chatBoxRef} w={"100%"} maxW={"100%"} paddingX={"16px"} height={`calc(100% - 20px - -32px - 16px - 88px - 24px)`} maxH={`calc(100% - 20px - 2*16px - 88px - 24px)`}>
                <Box height={"100px"} w={"100%"} maxW={"100%"}>
                    <Box height={"76px"} w={"100%"} maxW={"100%"}>
                        {entityChatData?.questions?.sort(
                            (a, b) => a.display_order - b.display_order
                        ).map((item, index) => (
                            index < 3 && (
                                <HStack key={index} marginY={"2px"} lineHeight={"21px"} spacing={"4px"} w={"100%"} maxW={"100%"}>
                                    <Text 
                                        w={"80px"}
                                        maxW={"80px"}
                                        maxH={"21px"}
                                        isTruncated
                                        fontSize={"16px"}
                                        fontWeight={"regular"}
                                        color={"#1d1d1d"}
                                    >{item.header}</Text>
                                    <Text 
                                        w={`calc(100% - 80px)`}
                                        maxW={`calc(100% - 80px)`}
                                        maxH={"21px"}
                                        isTruncated
                                        fontSize={"16px"}
                                        fontWeight={"regular"}
                                        color={"#3d3d3d"}
                                    >{item.value}</Text>
                                </HStack>
                            )
                        ))}
                    </Box>

                    <HStack height={"24px"} w={"100%"} maxW={"100%"} spacing={0} marginTop={"16px"}>
                        <Text
                            w={`calc(100% - 154px)`}
                            maxW={`calc(100% - 154px)`}
                        >
                        </Text>
                        <HStack 
                            w={"154px"}
                            maxW={"154px"}
                            justifyContent={"right"}
                            gap={0}
                            // position="relative"
                        >
                            {getCollaborators()?.map((item, index) => (
                                index < 4 && (
                                    <Avatar
                                        key={index}
                                        sx={{
                                            boxSize: "24px",
                                            // position: "absolute",
                                            // left: `${index * 24}px`, // Adjust overlap distance
                                            // zIndex: `${index - 4 }`, // Ensure proper stacking
                                            // border: "2px solid white", // Add border for better visibility
                                        }}
                                        name={item.first_name}
                                        src={item.profile_photo}
                                    />
                                )
                            ))}
                            <Text
                                marginLeft={"4px"}
                                w={"56px"}
                                color={"#2584FD"}
                                noOfLines={1}
                                fontSize={"14px"}
                            >
                                {
                                    getCollaborators()?.length > 4 ? `+${getCollaborators()?.length - 4} more` : ""
                                }
                            </Text>
                        </HStack>
                    </HStack>
                </Box>
                <Box marginTop={"24px"} maxH={`calc(100% - 100px - 28px)`} overflowY={"scroll"} data-scrollable="true">
                    <ConversationMessages conversation={getConversation()} collaboratorMapping={collaboratorMapping} applySuggestion={applySuggestion} setIsEntityChatOpen={setIsEntityChatOpen}/>
                </Box>
            </Box>
            <Box
                paddingX={"16px"}
                minHeight={"88px"} 
                maxH={`calc(88px + 64px)`}
                width={"100%"}
                marginBottom={"24px"}
            >
                <Box
                    // height={"88px"} 
                    // maxH={`100%`}
                    width={"100%"}
                    borderRadius={"24px"}
                    border={"1px solid #E1E5E9"}
                    paddingX={"24px"}
                    paddingY={"16px"}
                    backgroundColor={"#F6F8FA"}
                >
                    <VStack
                        // height={"56px"}
                        // maxH={`calc(100% - 32px)`}
                        width={"100%"}
                        borderRadius={"16px"}
                        backgroundColor={"#FFFFFF"}
                        paddingX={"8px"}
                        paddingY={"12px"}
                        gap={"4px"}
                        align={"flex-start"}
                    >
                        <HStack width={"100%"}>
                            <Textarea
                                rows={1}
                                ref={textareaRef}
                                data-scrollable="true"
                                placeholder="Enter comment"
                                height={"32px"}
                                maxH={"32px"}
                                minH={"unset"}
                                resize="none"
                                padding={0}
                                overflow="hidden"
                                backgroundColor="white"
                                variant="unstyled"
                                value={typedMessage}
                                lineHeight={"24px"}
                                onChange={(e) => setTypedMessage(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && e.shiftKey) {
                                        e.preventDefault();
                                        setTypedMessage((prev) => prev + "\n");
                                    } else {
                                        handleKeyDown(e, getConversation(), selectedConversationTab);
                                    }
                                }}
                            >
                            </Textarea>
                            <IconButton
                                sx={{
                                    padding: "0",
                                    margin: "0",
                                    backgroundColor: typedMessage.trim() !== "" ? "#2584FD" : "#C4E0FF",
                                    "&:hover": {
                                        backgroundColor: typedMessage.trim() !== "" ? "#2584FD" : "#C4E0FF",
                                    },
                                    height: "32px",
                                    width: "32px",
                                    borderRadius: "32px",
                                    minW: "32px",
                                }}
                                onClick={() => handleSendMessage(getConversation(), selectedConversationTab)}
                            >
                                <Send
                                    sx={{
                                        padding: "0",
                                        margin: "0",
                                        fontSize: "19px",
                                        color: "white",
                                        "&:hover": {
                                            color: "white",
                                        }
                                    }}
                                />
                            </IconButton>
                        </HStack>
                        {
                            selectedConversationTab == "ai_chat" && (<HStack>
                            {
                                improveWithAI.map((item, index) => (
                                    <HStack
                                        key={index}
                                        backgroundColor={"#E4F0FF"}
                                        paddingX={"16px"}
                                        paddingY={"2px"}
                                        borderRadius={"8px"}
                                        gap={"4px"}
                                        _hover={{
                                            backgroundColor: "#E4F0FF",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => setTypedMessage(item.value)}
                                    >
                                        <Text>
                                            {item.name}
                                        </Text>
                                    </HStack>
                                ))
                            }
                            </HStack>)
                        }
                    </VStack>

                </Box>
                
            </Box>
        </VStack>
    )
}

const ConversationMessages = ({conversation, collaboratorMapping, applySuggestion, setIsEntityChatOpen}) => {
    const [timezone, setTimezone] = React.useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
    {console.log("[ConversationPanel] conversation", conversation)}

    if (!conversation || !conversation?.messages || conversation?.messages?.length === 0) {
        return (
            <Box>No Comments</Box>
        )
    }

    return (
        <VStack spacing={"24px"}>
            {conversation?.messages?.map((item, index) => {
                const collaborator = collaboratorMapping[item.message_by.email];
                if (item.message_type === "plain_text") {
                    return getPlainTextMessage(index, item, collaborator, timezone);
                } else if (item.message_type === "mark_approved") {
                    return markApprovedMessage(index, item, collaborator, timezone);
                } else if (item.message_type === "qa_entity_data_answer") {
                    return <QASuggestionMessage index={index} item={item} collaborator={collaborator} timezone={timezone} applySuggestion={applySuggestion} setIsEntityChatOpen={setIsEntityChatOpen}/>;
                } else if (item.message_type === "edit_answer") {
                    return <EditedAnswerMessage index={index} item={item} collaborator={collaborator} timezone={timezone} applySuggestion={applySuggestion} setIsEntityChatOpen={setIsEntityChatOpen}/>;
                }
            })}
        </VStack>
    )
}

const EditedAnswerMessage = ({index, item, collaborator, timezone, applySuggestion, setIsEntityChatOpen}) => {
    const [viewFullSuggestion, setViewFullSuggestion] = React.useState(false);
    const [collapsedInfo, setCollapsedInfo] = React.useState(true);

    if (collapsedInfo) {
        return (
            <Box
                key={index} 
                w={"100%"} 
                maxW={"100%"}
                paddingX={"16px"}
                margin={0}
            >
                <HStack
                    justifyContent="center"
                    alignItems="center"
                    spacing={"4px"}
                    onClick={() => {setCollapsedInfo(!collapsedInfo)}}
                >
                    <Avatar
                        key={index}
                        sx={{
                            boxSize: "20px",
                        }}
                        name={collaborator?.first_name}
                        src={collaborator?.profile_photo}
                    />
                    <Text
                        lineHeight={"20px"}
                        fontSize={"14px"}
                        fontWeight={"medium"}
                        color={"#8696a0"} // Dark green text
                        paddingX={"16px"}
                        margin={0}
                        padding={0}
                        maxW={`calc(100% - 28px)`}
                        isTruncated
                        cursor={"pointer"}
                    >
                        {collaborator?.first_name + " " + collaborator?.last_name + " edited the answer"}
                    </Text>
                </HStack>
            </Box>
        )
    }

    return (
        <HStack 
            key={index} 
            w={"100%"} 
            maxW={"100%"} 
            spacing={"12px"} 
            alignItems={"flex-start"}
        >
            <Avatar
                key={index}
                sx={{
                    boxSize: "40px",
                }}
                name={collaborator?.first_name}
                src={collaborator?.profile_photo}
            />
            <VStack spacing={0} alignItems={"flex-start"} width="100%">
                <HStack width={"100%"} justifyContent={"space-between"}>
                    <VStack alignItems={"flex-start"} spacing={0}>
                        <Text
                            lineHeight={"24px"}
                            fontSize={"14px"}
                            fontWeight={"medium"}
                            color={"#3d3d3d"}
                        >
                            {collaborator?.first_name + " " + collaborator?.last_name}
                        </Text>
                        <Text
                            lineHeight={"16px"}
                            fontSize={"12px"}
                            fontWeight={"regular"}
                            color={"#5d5d5d"}
                        >
                            {new Date(item.message_time).toLocaleString('en-GB', {
                                timeZone: timezone,
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                            })}
                        </Text>
                    </VStack>
                    <IconButton
                        sx={{
                            padding: "0",
                            margin: "0",
                            backgroundColor: "transparent",
                            "&:hover": {
                                backgroundColor: "transparent",
                            },
                            height: "18px",
                            width: "18px",
                            minW: "unset",
                        }}
                        onClick={() => {setCollapsedInfo(!collapsedInfo)}}
                    >
                        <Close
                            sx={{
                                padding: "0",
                                margin: "0",
                                fontSize: "18px",
                                color: "#5d5d5d",
                                "&:hover": {
                                    color: "#2584FD",
                                }
                            }}
                        />
                    </IconButton>
                </HStack>
                <Box marginTop={"8px"}>
                    {
                        item.message_data?.qa_entity_data_answer.map((answer, index) => <RenderAnswer answer={answer} index={index} viewFullSuggestion={viewFullSuggestion} setViewFullSuggestion={setViewFullSuggestion}/>)
                    }
                    {/* {
                        item.message_data?.qa_entity_data_answer.map((answer, index) => (
                            <HStack
                                key={index}
                                marginY={"2px"}
                                lineHeight={"21px"}
                                spacing={"8px"}
                                w={"100%"}
                                maxW={"100%"}
                                onClick={() => {setViewFullSuggestion(!viewFullSuggestion)}}
                                cursor={"pointer"}
                            >
                                <Text
                                    maxW={"25%"}
                                    lineHeight={"16px"}
                                    fontSize={"12px"}
                                    fontWeight={"regular"}
                                    color={"#1d1d1d"}
                                    noOfLines={viewFullSuggestion ? "" : 1}
                                >
                                    {answer.header}
                                </Text>
                                <Text
                                    maxW={"75%"}
                                    lineHeight={"16px"}
                                    fontSize={"12px"}
                                    fontWeight={"regular"}
                                    color={"#1d1d1d"}
                                    noOfLines={viewFullSuggestion ? "" : 1}
                                >
                                    {answer.value?.text}
                                </Text>
                            </HStack>   
                        ))
                    } */}
                </Box>
                <HStack marginTop={"12px"} justifyContent="space-between" width={`calc(100% - 10px)`} spacing={0}>
                    <HStack spacing={"4px"} width={"70px"}>
                    </HStack>
                    <HStack spacing={"4px"} maxW={`calc(100%-70px)`} cursor={"pointer"}>
                        <IconButton
                            sx={{
                                padding: "0",
                                margin: "0",
                                backgroundColor: "transparent",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                },
                                height: "13px",
                                width: "13px",
                                minW: "unset",
                            }}
                        >
                            <Undo
                                sx={{
                                    padding: "0",
                                    margin: "0",
                                    fontSize: "12px",
                                    color: "#2584FD",
                                    "&:hover": {
                                        color: "#2584FD",
                                    }
                                }}
                            />
                        </IconButton>
                        <Text
                            lineHeight={"16px"}
                            fontSize={"12px"}
                            color={"#2584FD"}
                            fontWeight={"medium"}
                            onClick={() => {
                                setIsEntityChatOpen(false)
                                setTimeout(() => {
                                    applySuggestion(item.message_data?.qa_entity_data_answer);
                                }, 0);
                            }}
                        >
                            Revert answer
                        </Text>
                    </HStack>
                </HStack>
            </VStack>
        </HStack>
    )
}

const QASuggestionMessage = ({index, item, collaborator, timezone, applySuggestion, setIsEntityChatOpen}) => {
    const [viewFullSuggestion, setViewFullSuggestion] = React.useState(false);

    return (
        <HStack 
            key={index} 
            w={"100%"} 
            maxW={"100%"} 
            spacing={"12px"} 
            alignItems={"flex-start"}
        >
            <Avatar
                key={index}
                sx={{
                    boxSize: "40px",
                }}
                name={collaborator?.first_name}
                src={collaborator?.profile_photo}
            />
            <VStack spacing={0} alignItems={"flex-start"} width="100%">
                <HStack>
                    <VStack alignItems={"flex-start"} spacing={0}>
                        <Text
                            lineHeight={"24px"}
                            fontSize={"14px"}
                            fontWeight={"medium"}
                            color={"#3d3d3d"}
                        >
                            {collaborator?.first_name + " " + collaborator?.last_name}
                        </Text>
                        <Text
                            lineHeight={"16px"}
                            fontSize={"12px"}
                            fontWeight={"regular"}
                            color={"#5d5d5d"}
                        >
                            {new Date(item.message_time).toLocaleString('en-GB', {
                                timeZone: timezone,
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                            })}
                        </Text>
                    </VStack>
                </HStack>
                <Box marginTop={"8px"} w={"100%"} maxW={"100%"}>
                    {
                        item.message_data?.qa_entity_data_answer.map((answer, index) => <RenderAnswer answer={answer} index={index} viewFullSuggestion={viewFullSuggestion} setViewFullSuggestion={setViewFullSuggestion}/>)
                    }
                </Box>
                <HStack marginTop={"12px"} justifyContent="space-between" width={`calc(100% - 10px)`} spacing={0}>
                    <HStack spacing={"4px"} width={"70px"}>
                        <IconButton
                            sx={{
                                padding: "0",
                                margin: "0",
                                backgroundColor: "transparent",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                },
                                height: "16px",
                                width: "16px",
                                minW: "unset",
                            }}
                        >
                            <ThumbUpOutlined
                                sx={{
                                    padding: "0",
                                    margin: "0",
                                    fontSize: "16px",
                                    color: "#5d5d5d",
                                    "&:hover": {
                                        color: "#2584FD",
                                    }
                                }}
                            />
                        </IconButton>
                        <Text
                            lineHeight={"16px"}
                            fontSize={"12px"}
                            fontWeight={"regular"}
                            color={"#1d1d1d"}
                            padding={0}
                            margin={0}
                        >
                            0
                        </Text>
                        <IconButton
                            sx={{
                                padding: "0",
                                margin: "0",
                                marginLeft: "8px",
                                backgroundColor: "transparent",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                },
                                height: "16px",
                                width: "16px",
                                minW: "unset",
                            }}
                        >
                            <ThumbDownOutlined
                                sx={{
                                    padding: "0",
                                    margin: "0",
                                    fontSize: "16px",
                                    color: "#5d5d5d",
                                    "&:hover": {
                                        color: "#2584FD",
                                    }
                                }}
                            />
                        </IconButton>
                        <Text
                            lineHeight={"16px"}
                            fontSize={"12px"}
                            fontWeight={"regular"}
                            color={"#1d1d1d"}
                            padding={0}
                            margin={0}
                        >
                            0
                        </Text>
                    </HStack>
                    <HStack spacing={"4px"} maxW={`calc(100%-70px)`} cursor={"pointer"}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "11px",
                                height: "11px",
                                transform: "rotate(45deg)",
                                border: "1px solid #2584FD",
                                borderRadius: "3px",
                                backgroundColor: "transparent",
                                padding: "0",
                                margin: "0",
                            }}
                        >
                            <IconButton
                                sx={{
                                    transform: "rotate(-45deg)",
                                    padding: "0",
                                    margin: "0",
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                        backgroundColor: "transparent",
                                    },
                                    height: "13px",
                                    width: "13px",
                                    minW: "unset",
                                }}
                            >
                                <Add
                                    sx={{
                                        padding: "0",
                                        margin: "0",
                                        fontSize: "12px",
                                        color: "#2584FD",
                                        "&:hover": {
                                            color: "#2584FD",
                                        }
                                    }}
                                />
                            </IconButton>
                        </Box>
                        <Text
                            lineHeight={"16px"}
                            fontSize={"12px"}
                            color={"#2584FD"}
                            fontWeight={"medium"}
                            onClick={() => {
                                setIsEntityChatOpen(false);
                                setTimeout(() => {
                                    applySuggestion(item.message_data?.qa_entity_data_answer);
                                }, 0);
                            }}
                        >
                            Apply to answer
                        </Text>
                    </HStack>
                </HStack>
            </VStack>
        </HStack>
    )
}

const RenderAnswer = ({answer, index, viewFullSuggestion, setViewFullSuggestion}) => {
    const textRef = React.useRef(null);
    const textBoxRef = React.useRef(null);
    const [isTruncated, setIsTruncated] = React.useState(false);

    React.useEffect(() => {
        if (textRef.current && !viewFullSuggestion) {
            console.log("textRef.current", textRef.current.scrollWidth, textBoxRef.current.scrollWidth)
            setIsTruncated(textRef.current.scrollWidth >= textBoxRef.current.scrollWidth);
        } else {
            setIsTruncated(false);
        }
    }, [answer.value?.text, viewFullSuggestion]);


    return (
        <HStack
            key={index}
            marginY={"2px"}
            lineHeight={"21px"}
            spacing={"8px"}
            w={"100%"}
            maxW={"100%"}
            onClick={() => {setViewFullSuggestion(!viewFullSuggestion)}}
            cursor={"pointer"}
        >
            <Text
                maxW={"25%"}
                lineHeight={"16px"}
                fontSize={"12px"}
                fontWeight={"regular"}
                color={"#1d1d1d"}
                noOfLines={viewFullSuggestion ? "" : 1}
                whiteSpace="pre-line" // This ensures \n is rendered as a new line
            >
                {answer.header}
            </Text>
            <Box
                ref={textBoxRef}
                padding={0}
                margin={0}
                maxW={"75%"}
                w={"75%"}
            >
                <VStack
                    padding={0}
                    margin={0}
                    align={"flex-start"}
                    spacing={0}
                    display={"flex"}
                    maxW={"100%"}
                >
                    <Text
                        ref={textRef}
                        maxW={"100%"}
                        lineHeight={"16px"}
                        fontSize={"12px"}
                        fontWeight={"regular"}
                        color={"#1d1d1d"}
                        noOfLines={viewFullSuggestion ? "" : 1}
                        whiteSpace="pre-line" // This ensures \n is rendered as a new line
                    >
                        {answer.value?.text}
                    </Text>
                    {
                        !viewFullSuggestion && isTruncated && (
                            <Text
                                maxW={"58px"}
                                lineHeight={"16px"}
                                fontSize={"12px"}
                                fontWeight={"regular"}
                                color={"#2584FD"}
                                noOfLines={1}
                            >
                                read more
                            </Text>
                        )
                    }
                </VStack>
            </Box>
        </HStack>   
    )
}

const markApprovedMessage = (index, item, collaborator, timezone) => {
    return (
        <Box
            key={index} 
            w={"100%"} 
            maxW={"100%"}
            paddingX={"16px"}
            margin={0}
        >
            <HStack
                justifyContent="center"
                alignItems="center"
                spacing={"4px"}
            >
                <Avatar
                    key={index}
                    sx={{
                        boxSize: "20px",
                    }}
                    name={collaborator?.first_name}
                    src={collaborator?.profile_photo}
                />
                <Text
                    lineHeight={"20px"}
                    fontSize={"14px"}
                    fontWeight={"medium"}
                    color={"#2E7D32"} // Dark green text
                    paddingX={"16px"}
                    margin={0}
                    padding={0}
                    maxW={`calc(100% - 28px)`}
                    isTruncated
                >
                    {collaborator?.first_name + " " + collaborator?.last_name + " approved the answer"}
                </Text>
            </HStack>
        </Box>
    )
}

const getPlainTextMessage = (index, item, collaborator, timezone) => {
    return (
        <HStack 
            key={index} 
            w={"100%"} 
            maxW={"100%"} 
            spacing={"12px"} 
            alignItems={"flex-start"}
        >
            <Avatar
                key={index}
                sx={{
                    boxSize: "40px",
                }}
                name={collaborator?.first_name}
                src={collaborator?.profile_photo}
            />
            <VStack spacing={0} alignItems={"flex-start"}>
                <HStack>
                    <VStack alignItems={"flex-start"} spacing={0}>
                        <Text
                            lineHeight={"24px"}
                            fontSize={"14px"}
                            fontWeight={"medium"}
                            color={"#3d3d3d"}
                        >
                            {collaborator?.first_name + " " + collaborator?.last_name}
                        </Text>
                        <Text
                            lineHeight={"16px"}
                            fontSize={"12px"}
                            fontWeight={"regular"}
                            color={"#5d5d5d"}
                        >
                            {new Date(item.message_time).toLocaleString('en-GB', {
                                timeZone: timezone,
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                            })}
                        </Text>
                    </VStack>
                </HStack>
                <Box marginTop={"8px"}>
                    <Text
                        lineHeight={"16px"}
                        fontSize={"12px"}
                        fontWeight={"regular"}
                        color={"#1d1d1d"}
                        whiteSpace="pre-line" // This ensures \n is rendered as a new line
                    >
                        {item.message_data?.text}
                    </Text>
                </Box>
                <HStack marginTop={"12px"}>
                    <HStack spacing={"4px"}>
                        <IconButton
                            sx={{
                                padding: "0",
                                margin: "0",
                                backgroundColor: "transparent",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                },
                                height: "16px",
                                width: "16px",
                                minW: "unset",
                            }}
                        >
                            <ThumbUpOutlined
                                sx={{
                                    padding: "0",
                                    margin: "0",
                                    fontSize: "16px",
                                    color: "#5d5d5d",
                                    "&:hover": {
                                        color: "#2584FD",
                                    }
                                }}
                            />
                        </IconButton>
                        <Text
                            lineHeight={"16px"}
                            fontSize={"12px"}
                            fontWeight={"regular"}
                            color={"#1d1d1d"}
                            padding={0}
                            margin={0}
                        >
                            0
                        </Text>
                        <IconButton
                            sx={{
                                padding: "0",
                                margin: "0",
                                marginLeft: "8px",
                                backgroundColor: "transparent",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                },
                                height: "16px",
                                width: "16px",
                                minW: "unset",
                            }}
                        >
                            <ThumbDownOutlined
                                sx={{
                                    padding: "0",
                                    margin: "0",
                                    fontSize: "16px",
                                    color: "#5d5d5d",
                                    "&:hover": {
                                        color: "#2584FD",
                                    }
                                }}
                            />
                        </IconButton>
                        <Text
                            lineHeight={"16px"}
                            fontSize={"12px"}
                            fontWeight={"regular"}
                            color={"#1d1d1d"}
                            padding={0}
                            margin={0}
                        >
                            0
                        </Text>
                    </HStack>
                </HStack>
            </VStack>
        </HStack>
    )
}

export default ConversationPanel;